export default __webpack_public_path__ + "static/media/section1-slide-C1.6c930c5b.jpg";